export enum InvoicesOlsaMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_INVOICES_OLSA = 'SET_INVOICES_OLSA',
  SET_SELECTED_INVOICE_OLSA = 'SET_SELECTED_INVOICE_OLSA',
  SET_INVOICES_OLSA_TOTAL = 'SET_INVOICES_OLSA_TOTAL',
  SET_ERROR = 'SET_ERROR',
  SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE',
}
